<div class="negative-card shadow-sm">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faMinusCircle" style="font-size: 14px; color: #991B1B;"></fa-icon>
      <span class="main-heading fw-smbold">Negative stock</span>
      <span class="heading-value fw-bold ms-1">{{ stockCount | number }}</span>
    </div>
    @if (negativeStockList.length > 3) {
      <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllNegativeStock(negativeStockModal)">
        View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
      </button>
    }
  </div>

  <!-- Table -->
  <div class="table-box">
    <table class="table custom-table bg-transparent mb-0">
      <thead>
        <tr>
          <th class="fw-bold bg-transparent border-0" style="width: 38%;">SKU</th>
          <th class="fw-bold bg-transparent border-0 text-center" style="width: 22%;">Branch</th>
          <th class="fw-bold bg-transparent border-0 text-center" style="width: 28%; white-space: nowrap;">Last sale date</th>
          <th class="text-end fw-bold bg-transparent border-0" style="width: 12%;">Qty</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
          <tr>
            <td colspan="4" class="text-center py-4 border-0">
              <app-loader [loadingIcon]="loader"></app-loader>
            </td>
          </tr>
        }
        <!-- Error State -->
        @if (!loader && errMsg) {
          <tr>
            <td colspan="4" class="text-center py-4 border-0">
              <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
            </td>
          </tr>
        }
        <!-- Data State -->
        @if (!loader && !errMsg) {
          @for (item of negativeStockList | slice:0:3; track item) {
            <tr [class.highlight-today]="item.isToday" class="cursor-pointer" (click)="onRowClick(item)">
              <td class="td-col-1 bg-transparent border-0" style="width: 38%;">{{ item.sku }}</td>
              <td class="td-col-2 bg-transparent border-0 text-center" style="width: 22%;">{{ item.branch }}</td>
              <td class="td-col-4 bg-transparent border-0 text-center" style="width: 28%; white-space: nowrap;">{{ (item.lastSaleDate | date:'dd MMM yyyy':'Asia/Kolkata') || '-' }}</td>
              <td class="text-end td-col-3 fw-bold bg-transparent border-0" style="width: 12%;">{{ item.qty | number }}</td>
            </tr>
          }
          @if (negativeStockList.length === 0) {
            <tr>
              <td colspan="4" class="text-center py-4 border-0">
                <p class="text-muted mb-0 small fw-bold">No negative stock found.</p>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <!-- Footer -->
  @if (negativeStockList.length) {
    <div class="footer-text mt-1">
      <fa-icon [icon]="faShieldHalved"></fa-icon>
      <span>Fix sale / purchase entries to resolve negative stock value</span>
    </div>
  }
</div>

<!-- Modal Template -->
<ng-template #negativeStockModal let-modal>
  <div class="modal-header border-0 pb-0">
    <div class="d-flex align-items-center gap-2">
      <h5 class="fw-bold mb-0 main-heading">Negative Stock</h5>
      <span class="heading-value fw-bold ms-1">{{ stockCount | number }}</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1" style="max-height: 60vh; overflow-y: auto;"
      infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
      [scrollWindow]="false" (scrolled)="onScroll()">
      <table class="table custom-table bg-transparent mb-0">
        <thead style="position: sticky; top: 0; background: white; z-index: 1;">
          <tr>
            <th class="fw-bold bg-transparent border-0" style="width: 38%;">SKU</th>
            <th class="fw-bold bg-transparent border-0" style="width: 22%;">Branch</th>
            <th class="fw-bold bg-transparent border-0 text-center" style="width: 28%; white-space: nowrap;">Last sale date</th>
            <th class="text-end fw-bold bg-transparent border-0" style="width: 12%;">Qty</th>
          </tr>
        </thead>
        <tbody>
          @for (item of negativeStockList; track item) {
            <tr [class.highlight-today]="item.isToday" class="cursor-pointer" (click)="onRowClick(item)">
              <td class="td-col-1 bg-transparent border-0" style="width: 38%;">{{ item.sku }}</td>
              <td class="td-col-2 bg-transparent border-0" style="width: 22%;">{{ item.branch }}</td>
              <td class="td-col-4 bg-transparent border-0  text-center" style="width: 28%; white-space: nowrap;">{{ (item.lastSaleDate | date:'dd MMM yyyy':'Asia/Kolkata') || '-' }}</td>
              <td class="text-end td-col-3 fw-bold bg-transparent border-0" style="width: 12%;">{{ item.qty | number }}</td>
            </tr>
          }
        </tbody>
      </table>

      @if (scroolLoader) {
        <div class="d-flex justify-content-center py-3">
          <app-loader [loadingIcon]="scroolLoader"></app-loader>
        </div>
      }

      @if (endOfResults && negativeStockList.length > 0) {
        <div class="text-center py-3 text-muted small">
          End of results.
        </div>
      }
    </div>
  </div>
</ng-template>
